import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios';
import {FilterMatchMode} from 'primevue/api'
import {JWTService} from '@/shared/services/jwt.js';
import router from './router'
import PrimeVue from 'primevue/config'
import Vuex from 'vuex';
import "tabulator-tables/dist/css/tabulator.min.css";


/* Imports de componentes externos */
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'; //calendário - datas
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import FileUpload from 'primevue/fileupload';
import Galleria from 'primevue/galleria';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext'
import MultiSelect from 'primevue/multiselect';
import PDropdown from 'primevue/dropdown';
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Sidebar from 'primevue/sidebar';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Image from 'primevue/image';
import ToggleButton from 'primevue/togglebutton';


import Tree from 'primevue/tree';

// import FloatingVue from 'floating-vue'

import { Dropdown, Menu, VTooltip} from 'floating-vue'

import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup'; //optional for column grouping
import DataTable from 'primevue/datatable';
import Row from 'primevue/row';



/* Imports GComponents */
import gFileUpload from './components/g-file-upload/g-file-upload.vue';
import gCard from './components/g-card/g-card.vue';
import gButton from './components/g-button/g-button.vue';
import gDateInput from './components/g-date-input/g-date-input.vue';
import gSteps from './components/g-steps/g-steps.vue';
import gForm from './components/g-form/g-form.vue';
import gCardResumo from './components/g-card-resumo/g-card-resumo.vue';
import gDataTable from './components/g-data-table/g-data-table.vue';
import gTabMenu from './components/g-tab-menu/g-tab-menu.vue';
import clienteDropdownItem from './components/cliente-dropdown-item/cliente-dropdown-item.vue'
import transportadoraDropdownItem from './components/transportadora-dropdown-item/transportadora-dropdown-item.vue'
import quantidadeDropdownItem from './components/quantidade-dropdown-item/quantidade-dropdown-item.vue'
import gClaims from './components/g-claims/g-claims.vue'
import produtoDropdownItem from './components/produto-dropdown-item/produto-dropdown-item.vue'
import cnpjExistente from './components/popupCNPJExistente/cnpjExistente.vue';
import clienteDropdown from './components/cliente-dropdown/cliente-dropdown.vue';
import gTituloSteps from './components/g-titulo-steps/g-titulo-steps.vue';

import gGalleria from './components/g-galleria/g-galleria.vue';
import Loading from 'vue3-loading-screen'
import EstilizacaoGlobal from './pages/EstilizacaoGlobal/EstilizacaoGlobal.vue'
import Html2pdf from 'vue3-html2pdf'

/* Imports CSS */
import 'primeicons/primeicons.css'
// import 'primevue/resources/themes/saga-blue/theme.css' //theme
import '@/assets/custom-theme.css'
import 'primevue/resources/primevue.min.css' //core css
import 'floating-vue/dist/style.css' //icons
import mitt from 'mitt';
import VirtualScroller from 'primevue/virtualscroller';

axios.defaults.headers.common['Authorization'] = `Bearer ${JWTService.GetToken()}`;

const store = new Vuex.Store({
  state: {
    cliente: {}
  },
  getters: {
  },
  mutations: {
    initialiseStore(state) {
			// Check if the ID exists
			if(localStorage.getItem('store')) {
        this.replaceState(
					Object.assign(state, JSON.parse(localStorage.getItem('store')))
				);
			}
		},
    salvando(state) {
      localStorage.setItem('store', JSON.stringify(state));
    },
    limpandoCliente(state){
      state.cliente = {}
    }
  }
})

store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('store', JSON.stringify(state));
});


/* app */
const app = createApp(App)
  .use(Vuex)
  .use(ToastService)
  .use(router)
  .use(Html2pdf)
  .use(Loading, {

    bg: '#8a8a8a71',
    slot: `
      <div class="px-5 py-3 bg-gray-800 rounded">
        <h3 class="text-3xl text-white"><i class="pi pi-spin pi-spinner"></i></h3>
      </div>
    `
  })
  // .use(FloatingVue, {
  //   menu:{
  //     $extend: 'dropdown '
  //   }
  // })
  .use(store)
  .use(PrimeVue, {
      locale: {
          startsWith: 'Começa com',
          contains: 'Contém',
          notContains: 'Não contém',
          endsWith: 'Termina com',
          equals: 'Igual',
          notEquals: 'Diferente',
          noFilter: 'Sem filtro',
          lt: 'Menor que',
          lte: 'Menor ou igual',
          gt: 'Maior que',
          gte: 'Maior ou igual',
          dateIs: 'Date is',
          dateIsNot: 'Date is not',
          dateBefore: 'Date is before',
          dateAfter: 'Date is after',
          clear: 'Limpar',
          apply: 'Aplicar',
          matchAll: 'Match All',
          matchAny: 'Match Any',
          addRule: 'Adicionar regra',
          removeRule: 'Remove regra',
          accept: 'Sim',
          reject: 'Não',
          choose: 'Escolha',
          upload: 'Upload',
          cancel: 'Cancelar',
          dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
          dayNamesMin: ["D","S","T","Q","Q","S","S"],
          monthNames: [ 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Maio", "Jun","Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          today: 'Hoje',
          weekHeader: 'Nº sem.',
          firstDayOfWeek: 1,
          dateFormat: 'dd/mm/yyyy',
          weak: 'Fraco',
          medium: 'Médio',
          strong: 'Forte',
          passwordPrompt: 'Insira a senha',
          emptyFilterMessage: 'Sem resultados',
          emptyMessage: 'Sem opções diponíveis'
      }
  });


/* Componentes Externos */
app.component('PAccordion', Accordion)
app.component('PVirtualScroller', VirtualScroller)
app.component('PAccordionTab', AccordionTab)
app.component('PAutoComplete', AutoComplete)
app.component('PButton', Button)
app.component('PCalendar', Calendar)
app.component('PCheckBox', Checkbox)
app.component('PColumn',Column)
app.component('PColumnGroup',ColumnGroup)
app.component('PDataTable',DataTable)
app.component('PDialog',Dialog)
app.component('PDropDown', PDropdown)
app.component('PFileUpload',FileUpload)
app.component('PGalleria', Galleria)
app.component('PInputMask', InputMask)
app.component('PInputNumber', InputNumber)
app.component('PInputText', InputText)
app.component('PRadioButton',RadioButton)
app.component('PRow',Row)
app.component('PSideBar', Sidebar)
app.component('PSteps', Steps)
app.component('PTabMenu', TabMenu)
app.component('PTextArea',Textarea)
app.component('PToast', Toast)
app.component('PTree', Tree);
app.component('PImage', Image)

app.component('PProgressBar', ProgressBar)
app.component('VDropdown', Dropdown)
app.component('VMenu', Menu)
app.component('VMultiSelect', MultiSelect)
app.component('PToggleButton', ToggleButton)

/* GComponents */
app.component('g-file-upload', gFileUpload)
app.component('g-titulo-steps', gTituloSteps)
app.component('g-card', gCard)
app.component('g-button', gButton)
app.component('g-claims', gClaims)
app.component('g-date-input', gDateInput)
app.component('g-steps', gSteps)
app.component('g-form', gForm)
app.component('g-card-resumo', gCardResumo)
app.component('g-data-table', gDataTable)
app.component('g-tab-menu', gTabMenu)
app.component('cnpjExistente',cnpjExistente)
app.component('g-galleria', gGalleria)
app.component('cliente-dropdown-item', clienteDropdownItem)
app.component('cliente-dropdown', clienteDropdown)
app.component('transportadora-dropdown-item', transportadoraDropdownItem)
app.component('produto-dropdown-item', produtoDropdownItem)
app.component('quantidade-dropdown-item', quantidadeDropdownItem)
app.component('EstilizacaoGlobal', EstilizacaoGlobal)
app.component('PDF', Html2pdf)
app.directive('tooltip', VTooltip)


/* Atributos globais */
const emitter = mitt()
app.config.globalProperties.axios = axios;
app.config.globalProperties.filtros = FilterMatchMode;
app.config.globalProperties.mitt = emitter;

app.mount('#app')

